import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=f0468682&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0468682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0468682')) {
      api.createRecord('f0468682', component.options)
    } else {
      api.reload('f0468682', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=f0468682&scoped=true&", function () {
      api.rerender('f0468682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Account/Sidebar.vue"
export default component.exports